var map = {
	"./bags": [
		"9235",
		"chunk-0ad2cce0"
	],
	"./bags.vue": [
		"9235",
		"chunk-0ad2cce0"
	],
	"./bottled": [
		"eb32",
		"chunk-6d13dc67"
	],
	"./bottled.vue": [
		"eb32",
		"chunk-6d13dc67"
	],
	"./details": [
		"b34a"
	],
	"./details.vue": [
		"b34a"
	],
	"./infusion": [
		"df52",
		"chunk-34a86a8e"
	],
	"./infusion.vue": [
		"df52",
		"chunk-34a86a8e"
	],
	"./medicine": [
		"41ec",
		"chunk-81349d2e"
	],
	"./medicine.vue": [
		"41ec",
		"chunk-81349d2e"
	],
	"./mixins": [
		"d736",
		"chunk-2d21eaec"
	],
	"./mixins.js": [
		"d736",
		"chunk-2d21eaec"
	],
	"./slices": [
		"5066",
		"chunk-49ec8aa5"
	],
	"./slices.vue": [
		"5066",
		"chunk-49ec8aa5"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1cc1";
module.exports = webpackAsyncContext;